<template>
        <a-modal
                title="标题"
                okText="确认"
                cancelText="取消"
                width="70%"
                :visible="visible"
                :confirm-loading="confirmLoading"
                @ok="handleOk"
                @cancel="handleCancel"
        >
            <a-form-model ref="ruleForm" :model="form" :rules="rules" :label-col="{span:4}" :wrapper-col="{span:14}">

                <a-form-model-item label="字段2" prop="filed1">
                    <a-input  placeholder="请输入密码333" autocomplete="off" v-model="form.filed1" />
                </a-form-model-item>

                <a-form-model-item label="字段2" prop="filed2">
                    <a-input  placeholder="请输入密码333" autocomplete="off" v-model="form.filed2" />
                </a-form-model-item>

                <a-form-model-item label="字段2" prop="filed3">
                    <a-input  placeholder="请输入密码333" autocomplete="off" v-model="form.filed3" />
                </a-form-model-item>

                <a-form-model-item label="字段2" prop="filed4">
                    <a-input  placeholder="请输入密码333" autocomplete="off" v-model="form.filed4" />
                </a-form-model-item>
            </a-form-model>
    </a-modal>
</template>

<script>
    import AExtArrayEditDemo from '../AntDesignExt/Demo/AExtArrayEditDemo'
    import AExtTaskSKDPickAndCheck from '../AntDesignExt/AExtTaskSKDPickAndCheck/index'
    import AExtUpload from '../AntDesignExt/Demo/AExtUpload'
    import {upload as upload,upload as load} from '../../api/api'

    export default {
        name: "FormModel",
        components:{AExtArrayEditDemo,AExtTaskSKDPickAndCheck,AExtUpload,},
        props:{
            visible:{
                type:Boolean,
                default:false
            },
            param:{
                type:Object,
                default: ()=>{
                    return {}
                }
            }
        },
        data() {
            return {
                confirmLoading: false,
                form:{
                    filed1:'',
                    filed2:'',
                    filed3:'',
                    filed4:''
                },
                rules:{
                    filed1:[{ required: true, message: '请输入文本框内容', trigger: 'blur' },],
                    filed2:[{ required: true, message: '请输入文本框内容', trigger: 'blur' },],
                    filed3:[{ required: true, message: '请输入文本框内容', trigger: 'blur' },],
                    filed4:[{ required: true, message: '请输入文本框内容', trigger: 'blur' },],
                },
            };
        },
        created(){
            this.initForm();
        },
        methods: {
            initForm(){
                this.confirmLoading = true;
                load(this.param).then((result=>{
                    this.form=result.data.data;
                    this.confirmLoading = false;
                })).catch(()=>{
                    this.confirmLoading = false;
                });
            },
            handleOk(e) {
                this.$refs.ruleForm.validate(valid => {
                    if (valid) {
                        this.confirmLoading = true;
                        upload(form).then((result=>{
                            this.confirmLoading = false;
                            this.$emit("update:visible",false)
                        })).catch(()=>{
                            this.confirmLoading = false;
                        });
                    } else {
                        return false;
                    }
                });
            },
            handleCancel(e) {
                this.$emit("update:visible",false)
            },
        },
    }
</script>

<style scoped lang="scss">

    /deep/ .ant-modal-body{
        height: 70vh;
        overflow-y: scroll;
    }

</style>